import { hydrateHeader } from '../../utils/header';

import '@messaging/scss/Reset.scss';
import './Gateway.scss';

export default () => {
  hydrateHeader();

  window.addEventListener('DOMContentLoaded', () => {
    window.ecGa('trackEvent', { eventAction: 'URLGatewayWarning', eventLabel: 'Shown' });
  });

  const submitForm = document.getElementById('submitForm');
  submitForm!.addEventListener('click', () => {
    window.ecGa('trackEvent', { eventAction: 'URLGatewayWarning', eventLabel: 'Proceed' });
    (document.getElementById('gatewayForm')! as HTMLFormElement).submit();
  });

  const goBack = document.getElementById('goBack');
  goBack!.addEventListener('click', () => {
    window.ecGa('trackEvent', { eventAction: 'URLGatewayWarning', eventLabel: 'Return' });
    window.location.assign(window.__CONFIG__.baseUrl);
  });
};
